const URL_TESLA_AUTH = "https://com-surpnorm-senseev.appspot.com/v1/tesla/auth";

class TeslaAuthApi {

  static requestHeaders(deviceId, authToken) {
    return {'Authorization': `Bearer deviceId="${deviceId}",authenticationToken="${authToken}"`}
  }

  static updateTeslaAuth(deviceId, authToken, teslaAuth) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_TESLA_AUTH}`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(teslaAuth)
    });

    return fetch(request).then(response => {
		if (response.status === 200) {
			return response.json();
		} else if (response.status === 401) {
			return {'error': 'Unauthenticated'};
		}
		return {'error': 'HTTP Status: ' + response.status};
    }).catch(error => {
      return error;
    });
  }
  
  static getTeslaAuthStatus(deviceId, authToken) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_TESLA_AUTH}`, {
      method: 'GET',
      headers: headers
    });

    return fetch(request).then(response => {
		if (response.status === 200) {
			return response.json();
		} else if (response.status === 401) {
			return {'error': 'Unauthenticated'};
		}
		return {'error': 'HTTP Status: ' + response.status};
    }).catch(error => {
      return error;
    });
  }
}

export default TeslaAuthApi;


// WEBPACK FOOTER //
// ./src/api/teslaAuthApi.js